module.exports = __webpack_public_path__ + "img/wgr.bd1572e4.svg";